import { useEffect, useState } from "react";
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import Select from "react-select";

import { requestApi } from "../../../actions/api";
import { encryptStorage } from "../../../constants/EncryptStorage";
import { GetLanguageString } from "../../helper/Components";
import FundFilter from "../../helper/SearchFilter/FundFilter";
import SelectUnit from "../../shared/SelectUnit";
import { ApiUnit } from "../../unit/ApiUnit";

const InfaqSearchFilters = ({ values, setValues, onSubmit, showAmount, loading = false }) => {
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [draftValues, setDraftValues] = useState(values);
  const excludeExUnit = draftValues?.excludeExUnit;
  const [memberTypeList, setMemberTypeList] = useState([]);

  useEffect(() => {
    setDraftValues(values);
  }, [values]);

  useEffect(() => {
    if (draftValues.unit.value === 0) {
      ApiUnit()
        .getUnit(loggedInUnitId, loggedInUnitId, excludeExUnit)
        .then((res) => {
          const temp = res.data.unitList[0];
          setDraftValues({
            ...draftValues,
            unit: { value: temp.id, lable: temp.name },
          });
        })
        .catch((err) => console.log(err));
    }
  // eslint-disable-next-line
  }, [loggedInUnitId, excludeExUnit]);

  useEffect(() => {
    requestApi("membertype/")
      .fetchAll()
      .then((res) => {
        setMemberTypeList(res.data);
      })
      .catch((err) => console.log(err));
  }, []);

  const memberTypeOptions = memberTypeList.map((d) => ({
    value: d.id,
    label: d.type,
  }));

  const selectedMemberTypes = memberTypeOptions.filter((option) =>
    (draftValues.memberTypeIds || []).includes(option.value)
  );

  const handleChangeMemberTypes = (record) => {
    if (record !== null) {
      setDraftValues({
        ...draftValues,
        memberTypeIds: record.map((r) => r.value),
      });
    } else {
      setDraftValues({
        ...draftValues,
        memberTypeIds: [],
      });
    }
  };

  const handleCheckBox = (e) => {
    const { name, value } = e.target;
    let v = value;
    if (value === "true") v = true;
    else v = false;
    setDraftValues({
      ...draftValues,
      [name]: v,
    });
  };

  const handleSearch = () => {
    if (loading) return;
    const searchValues = {
      ...draftValues,
      isSubUnits: true,
      displayMemberDetails: true,
    };
    setValues(searchValues);
    onSubmit(searchValues);
  };

  return (
    <div className="ibox-content">
      <FundFilter values={draftValues} setValues={setDraftValues} />
      <FormGroup>
        <Label className="col-form-label">
          {<GetLanguageString props="member_select_member_type" />}
        </Label>
        <div className="d-flex align-items-center">
          <div className="flex-grow-1">
            <Select
              options={memberTypeOptions}
              value={selectedMemberTypes}
              className="basic-multi-select ur"
              classNamePrefix="select"
              isMulti
              isClearable
              onChange={handleChangeMemberTypes}
            />
          </div>
          {showAmount ? (
            <FormGroup check className="mb-0 mx-3" style={{ whiteSpace: "nowrap" }}>
              <Label check for="infaqShowAmount" className="mb-0">
                <Input
                  id="infaqShowAmount"
                  type="checkbox"
                  name="showAmount"
                  value={!draftValues.showAmount}
                  onChange={handleCheckBox}
                />
                {<GetLanguageString props="funds_report_show_amount" />}
              </Label>
            </FormGroup>
          ) : null}
        </div>
      </FormGroup>
      <SelectUnit
        values={draftValues}
        setValues={setDraftValues}
        unitId={draftValues.unit.value}
        excludeExUnit={excludeExUnit}
        inlineWithArrows
      />
      <Row>
        <Col md="12" className="text-center m-t-sm">
          <Button
            color="primary"
            type="submit"
            onClick={handleSearch}
            disabled={loading}
          >
            {<GetLanguageString props="funds_submit" />}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default InfaqSearchFilters;
